module.exports = __webpack_public_path__ + "img/example_identification_col.3f1903b6.svg";